module.exports = {"140624100":"云中镇","140624101":"吴家窑镇","140624102":"金沙滩镇","140624103":"毛家皂镇","140624200":"何家堡乡","140624201":"新家园乡","140624202":"亲和乡","140624203":"海北头乡","140624204":"马辛庄乡","140624205":"河头乡","140624500":"金沙滩农牧场","140624501":"金沙滩林场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140624.json
// module id = 406
// module chunks = 0